<section class="lead-capture-container overflow-hidden h-100">
    <div [ngClass]="{'lead-container':save_contact_state === LEAD_SAVE_CONTACT_STATE.SAVING}" class="h-100">
        <div *ngIf="current_lead_state !== LEAD_STATE.ERROR_PARSING" class="captured-image position-relative w-100 rounded-2 shadow">
            <div class="w-100 h-100 rounded-2 position-absolute top-0 start-0 z-index-999" *ngIf="true || current_lead_state !== LEAD_STATE.EDIT">
                <app-processing-loader
                    [loadingMessage]="'Processing image data...'"
                ></app-processing-loader>
            </div>
            <img [src]="tempCapturedURLData" class="w-100 h-100 rounded-2 captured-temp-img"
                [ngClass]="{
                    'border border-success': image_processing_state === AFTER_IMAGE_PROCESSING.SUCCESS,
                    'border border-danger': image_processing_state === AFTER_IMAGE_PROCESSING.INVALID,
                }"
                alt="CapturedFrame" *ngIf="tempCapturedURLData"
            />
        </div>

        <!-- Error State -->
        <div class="error-state text-center p-4 h-100 d-flex justify-content-center align-items-center" *ngIf="current_lead_state === LEAD_STATE.ERROR_PARSING">
            <app-error-state
                (handleEnterManualEmitter)="handleEnterDetails()"
                (handleRetakeImageEmitter)="handleRetakeImage()"
            ></app-error-state>
        </div>
    </div>

    <!-- ALERT STATE -->
    <div class="mobile-alert-container" *ngIf="isMobileDevice">
        <div
            class="p-3"
            [ngClass]="{
                    'bg-danger d-flex gap-2': image_processing_state === AFTER_IMAGE_PROCESSING.INVALID,
                }"
        >
            <div *ngIf="image_processing_state === AFTER_IMAGE_PROCESSING.INVALID">
                <img
                    src="../../../assets/img/dbc-onboard-v2/exclamation-message.svg"
                    alt="Close"
                    width="20"
                    height="20"
                />
                <span class="ms-3 alert-text">
                    Failed to process image data.
                    </span>
            </div>
        </div>
    </div>
</section>
